export const getOrganizationApiHandler = {
  method: "GET",
  path: () => `organizations-dashboard`
};